module.exports = "<input type=\"text\" class=\"kuiTextInput\" placeholder=\"Placeholder text\">\n\n<hr class=\"guideBreak\">\n\n<input type=\"text\" class=\"kuiTextInput\" value=\"Entered text\" autofocus>\n\n<hr class=\"guideBreak\">\n\n<input type=\"text\" class=\"kuiTextInput\" required>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/form/text_input.html
 ** module id = 729
 ** module chunks = 0
 **/